import { z } from 'zod'

/**
 * 「緊急時お知らせ」zod スキーマおよび型定義.
 */

export const EMERGENCY_NOTIFICATION_ID = 1 // お知らせは 1 レコードを編集して使い回す運用想定.

// 種別。0=システム障害（赤） / 1=ニュース関連・その他（青）
export const emergencyNotificationTypeSchema = z.union([z.literal(0), z.literal(1)])

// GET /:emergency_notification_id
export const getEmergencyNotificationParamsSchema = z.object({
  emergency_notification_id: z.coerce.number().int().positive()
})

export const emergencyNotificationResponseSchema = z.object({
  title: z.string(),
  description: z.string().nullable(),
  type: emergencyNotificationTypeSchema,
  detail_url: z.string().nullable()
})

// POST / 既読登録
export const postEmergencyNotificationReadQuerySchema = z.object({
  groupId: z.coerce.number().int().positive()
})

export const postEmergencyNotificationReadBodySchema = z.object({
  emergency_notification_id: z.coerce.number().int().positive()
})

export const postEmergencyNotificationReadResponseSchema = z.literal(true)

export type EmergencyNotificationType = z.infer<typeof emergencyNotificationTypeSchema>
export type GetEmergencyNotificationParams = z.infer<typeof getEmergencyNotificationParamsSchema>
export type PostEmergencyNotificationReadQuery = z.infer<typeof postEmergencyNotificationReadQuerySchema>
export type PostEmergencyNotificationReadBody = z.infer<typeof postEmergencyNotificationReadBodySchema>

export type EmergencyNotificationResponse = z.infer<typeof emergencyNotificationResponseSchema>
export type PostEmergencyNotificationReadResponse = z.infer<typeof postEmergencyNotificationReadResponseSchema>
